<div class="modal-header">
  <h5 class="modal-title">
    <span *ngIf="!editMode">Add</span><span *ngIf="editMode">Edit</span> Case Note
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <form autocomplete="off" [formGroup]="notesForm">
    
    <div class="mb-3">
      <label class="form-label">Notes</label>
      <textarea class="form-control" 
                formControlName="caseNoteText" 
                rows="10"
                placeholder="Notes"></textarea>
    </div>

    <div class="form-check mb-3">
      <input class="form-check-input" 
             type="checkbox" 
             [checked]="showOnPortal1" 
             (change)="toggle(!showOnPortal1)"
             id="portalCheck">
      <label class="form-check-label" for="portalCheck">
        Add to Portal 1
      </label>
    </div>

  </form>
</div>

<div class="modal-footer">
  <button *ngIf="!isLoading && editMode" 
          type="button" 
          class="btn btn-success" 
          (click)="updateCaseNote()">
    Update
  </button>

  <button *ngIf="!isLoading && !editMode" 
          type="button" 
          class="btn btn-success" 
          (click)="saveNotes()">
    Save
  </button>

  <button *ngIf="isLoading" 
          type="button" 
          class="btn btn-success" 
          disabled>
    <span class="spinner-border spinner-border-sm me-2"></span>
    <span *ngIf="editMode">Updating...</span>
    <span *ngIf="!editMode">Saving...</span>
  </button>
</div>